import { render, staticRenderFns } from "./Laudo.vue?vue&type=template&id=3f5fda62&scoped=true&"
import script from "./Laudo.vue?vue&type=script&lang=js&"
export * from "./Laudo.vue?vue&type=script&lang=js&"
import style0 from "./Laudo.vue?vue&type=style&index=0&id=3f5fda62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fda62",
  null
  
)

export default component.exports